"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var dispatch_1 = require("../../components/utils/dispatch");
require("./styles.scss");
var Banner = function (props) {
    var dispatchers = (0, dispatch_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var iconMap = {
        INFO: 'fa-exclamation',
        FETCHED: 'fa-check',
        FAILED: 'fa-exclamation-triangle',
        WARNING: 'fa-exclamation'
    };
    var setNotificationIcon = function (type) {
        return iconMap[type] || 'fa-check';
    };
    var closeBanner = function () {
        props.setShowBanner(false);
        if (props.notificationType === 'FETCHED')
            dispatchers.clearStatus();
    };
    return (React.createElement("div", { className: "bid-banner-area ".concat(props.notificationType) },
        React.createElement("div", { className: "bid-banner-content" },
            React.createElement("span", { className: "bid-banner-icon" },
                React.createElement(sok_ui_1.Icon, { className: setNotificationIcon(props.notificationType) })),
            React.createElement("div", { className: "bid-banner-text" },
                React.createElement("span", null, (0, translation_1.getLocalization)("banner/".concat(props.notificationType))),
                React.createElement("span", null, props.bannerText))),
        React.createElement("button", { onClick: closeBanner, className: "bid-banner-close-button" },
            React.createElement(sok_ui_1.Icon, { className: "fa-times" }))));
};
exports.Banner = Banner;
